import details from './details/state'

export default {
  namespaced: true,
  modules: {
    details
  }
}
